/**
 * @file: ItemChip.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * An item from the originating visit. Unsolved faults stay flagged in red;
 * completed work recedes into the neutral chassis.
 */

import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { View } from 'react-native';
import { LD } from '../leadDetailKit';

export const ItemChip = ({
  name,
  solved,
}: {
  name: string;
  solved: boolean;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        paddingVertical: rpx(4),
        paddingHorizontal: rpx(10),
        borderRadius: rpx(13),
        marginLeft: rpx(5),
        marginVertical: rpx(2),
        backgroundColor: solved ? LD.hairline : LD.dangerSoft,
      }}
    >
      <Typography.Text size={rpx(12)} color={solved ? LD.steel : LD.danger}>
        {name}
      </Typography.Text>
    </View>
  );
};
